import { Injectable } from '@angular/core';
import { EmployeeOnboardingService } from 'app/services/employee-onboarding.service';
import 'rxjs/add/operator/do';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import {
  SkillTestGenerateResponse,
  SkillTestSubmitRequest,
  SkillTestResultResponse,
} from '../models/skill-learning.model';
import { SKILL_TESTS_API } from '../constants/skill-api.constants';
import { SKILL_LEARNING_LEVEL_COUNT } from '../options/skill-learning.option';

@Injectable()
export class SkillTestApiService {

  private readonly jsonHeaders = new Headers({ 'Content-Type': 'application/json' });
  private readonly jsonOptions = new RequestOptions({ headers: this.jsonHeaders });

  constructor(private http: Http, private onboarding: EmployeeOnboardingService) {}

  generateTest(
    specializationId: string,
    level: number = SKILL_LEARNING_LEVEL_COUNT.ONE,
  ): Observable<SkillTestGenerateResponse> {
    return this.http
      .post(SKILL_TESTS_API.GENERATE(specializationId, level), null, this.jsonOptions)
      .map(response => response.json() as SkillTestGenerateResponse);
  }

  submitTest(
    specializationId: string,
    request: SkillTestSubmitRequest,
    level: number = SKILL_LEARNING_LEVEL_COUNT.ONE,
  ): Observable<SkillTestResultResponse> {
    return this.http
      .post(SKILL_TESTS_API.SUBMIT(specializationId, level), JSON.stringify(request), this.jsonOptions)
      .map(response => response.json() as SkillTestResultResponse)
      .do(() => this.onboarding.invalidate());
  }

  fetchTestCooldownSeconds(
    specializationId: string,
    level: number = SKILL_LEARNING_LEVEL_COUNT.ONE,
  ): Observable<number> {
    return this.http
      .get(SKILL_TESTS_API.COOLDOWN(specializationId, level))
      .map(response => response.json() as number);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/services/skill-test-api.service.ts